import type { IconData } from '@stacksjs/iconify-core'

export const garage: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M448 255.454h-.511L407.067 164.5A48.04 48.04 0 0 0 363.2 136H148.8a48.04 48.04 0 0 0-43.863 28.5l-40.426 90.954H64a32.036 32.036 0 0 0-32 32v112a32.036 32.036 0 0 0 32 32V472a24.03 24.03 0 0 0 24 24h56a24.03 24.03 0 0 0 24-24v-40.546h176V472a24.03 24.03 0 0 0 24 24h56a24.03 24.03 0 0 0 24-24v-40.546a32.036 32.036 0 0 0 32-32v-112a32.036 32.036 0 0 0-32-32M134.175 177.5A16.01 16.01 0 0 1 148.8 168h214.4a16.01 16.01 0 0 1 14.621 9.5l34.646 77.953H99.529ZM136 464H96v-32.546h40Zm280 0h-40v-32.546h40Zm32-64.546H64v-112h384Z\"/><path fill=\"currentColor\" d=\"M96 328h80v32H96zm240 0h80v32h-80zM256 14.758L16 111.121v34.483l240-96.362l240 96.362v-34.483z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default garage
